<template>
  <header class="site-header">
    <div class="container-fluid">
      <div class="col-sm-10">
        <a class="logo" href="#" v-on:click="reloadPage">
          <img src="@/assets/images/2m-logo.png" alt="2M Holdings Ltd" />
        </a>
      </div>

      <div class="col-md-2">
        <h1>2M Brand</h1>
        <selectize class="form-break" name="brand" v-model="selectedBrand" :settings="selectizeSettings">
          <option value="Banner">Banner</option>
          <option value="Crafted">Crafted</option>
          <!--<option value="Ingretech">Ingretech</option>-->
          <option value="Stowlin">Stowlin</option>
          <option value="Surfachem">Surfachem</option>
          <option value="SurfachemDe">Surfachem DE</option>
          <option value="Bregaglio">Bregaglio</option>
        </selectize>
      </div>
    </div>
  </header>
</template>

<script>
  import Selectize from 'vue2-selectize';
  import axios from 'axios';

export default {
    name: 'AppHeader',
    components: {
      Selectize
    },
    data() {
      return {
        selectizeSettings: {
          maxOptions: 10000,
          sortField: [{ field: 'value', direction: 'asc' }, { field: '$score' }],
          allowEmptyOption: false,
          placeholder: 'Select brand'
        },
        selectedBrand: document.cookie.split('; ').find(cookie => cookie.startsWith('tenant='))
         ? document.cookie.split('; ').find(cookie => cookie.startsWith('tenant=')).split('=')[1]
         : null
      };
    },
    watch: {
      async selectedBrand(value) {
        // eslint-disable-next-line prefer-template


        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 7);

        document.cookie = `tenant=${value}; expires=${expirationDate.toUTCString()}; path=/`;

        this.$root.$emit('getDashboardData');
        this.$store.dispatch('getCustomers');
        this.$store.commit('updateBrandSelected', true);


        const appInfo = await axios.get('/app-info');

        document.title = appInfo.data.title;

        this.$store.commit('updateShouldShowSds', appInfo.data.shouldShowSds);
        this.$store.commit('updateShouldShowSpec', appInfo.data.shouldShowSpec);
      },
    },
    methods: {
      reloadPage(e) {
        e.preventDefault();
        // eslint-disable-next-line
        location.reload();
      },
    },
};
</script>
